import { NOTES_FAILED, NOTES_SUCCESS } from "../types";

const initialState = {
	error: false,
	message: "",
	title: "",
	singleNote: {},
	allNotes: {},
};

//selectors
export const getNotes = (state) => state.notes;

//reducers
export const noteReducer = (state = initialState, action) => {
	// console.log("I am the NOTE reducer action ======> ", action);
	switch (action.type) {
		case "NOTE":
			return {
				...state,
				error: false,
				title: action.message,
				singleNote: action.payload,
			};
		case "ALLNOTES":
			return {
				...state,
				error: false,
				title: action.message,
				allNotes: action.payload,
			};
		case NOTES_FAILED:
			return {
				...state,
				error: true,
				message: action.payload,
				title: action.title,
				code: action.code,
			};
		case NOTES_SUCCESS:
			return {
				...state,
				error: false,
				message: action.payload || action.message,
				title: action.title,
			};
		default:
			return {
				...state,
			};
	}
};
